import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CTA = () => {
  const navigate = useNavigate();

  return (
    <section className="relative py-28 lg:py-36 px-6 lg:px-10 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-br from-primary/10 via-background to-card">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent" />
      </div>

      <div className="relative max-w-[1100px] mx-auto text-center">
        <h2 className="text-[44px] sm:text-[56px] lg:text-[72px] leading-[1.05] font-semibold text-white">
          Bir Projeniz Mi Var?
        </h2>
        <p className="mt-7 text-[16px] lg:text-[17px] text-white/55 max-w-2xl mx-auto leading-relaxed">
          Profesyonel ekibimizden ucretsiz danismanlik ve fiyat teklifi almak
          icin bize ulasin.
        </p>
        <div className="mt-12">
          <button
            data-testid="cta-contact-button"
            onClick={() => navigate('/iletisim')}
            className="inline-flex items-center gap-3 px-9 py-4 rounded-full bg-gradient-to-b from-primary to-primary-hover text-primary-foreground text-[12px] font-semibold tracking-[0.2em] hover:from-primary-hover hover:to-primary-hover transition-all duration-300 shadow-xl shadow-primary/20 hover:-translate-y-0.5 group"
          >
            BIZE ULASIN
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
